export default "__VITE_ASSET__DrdVxr9o__"